import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type DCRState } from './dcr.types';

export const useDcrStore = create<DCRState>()(
	devtools(set => ({
		dcrFormSearchTerm: '',
		dcrFormFilteredFields: [],

		setDcrFormSearchTerm: (dcrFormSearchTerm: string) => {
			return set(() => ({
				dcrFormSearchTerm
			}));
		},
		setDcrFormFilteredFields: (
			dcrFormFilteredFields: Record<string, string[]>
		) =>
			set(() => ({
				dcrFormFilteredFields
			}))
	}))
);
